import alongsideSubtitle from '../alongsideSubtitle';
import { useEntityPageContext } from './EntityContext';

/**
 * A related-entities table on an entity page. Takes the table itself as `as`,
 * and passes through anything else it is given.
 *
 * Array dialect only - Google's affinity and brands tables take scalar
 * `categoryId`/`countryId` and stay written out at their call sites.
 */
const EntityRelatedTable = ({
    as: Table,
    subject,
    icon,
    title,
    exportType,
    exportEntity,
    sortParamKey,
    paginateBy,
    parented = false,
    dated = true,
    ...rest
}) => {
    const {
        entity,
        entityId,
        entityType,
        countryIds,
        week,
        year,
        name,
        exportName,
    } = useEntityPageContext();
    const isBrand = entityType === 'brands';

    return (
        <Table
            {...(paginateBy && { paginateBy })}
            {...(isBrand
                ? { brands: [entityId], countries: countryIds }
                : { categories: [entityId], countries: countryIds })}
            {...(dated && { week, year })}
            icon={icon}
            title={title}
            subtitle={alongsideSubtitle(subject, name)}
            filename={exportName(
                exportType,
                exportEntity === undefined ? {} : { entity: exportEntity },
            )}
            name={name}
            {...(parented && {
                parentEntity: entity,
                parentEntityType: isBrand ? 'brand' : 'category',
                parentEntityId: entityId,
            })}
            {...(sortParamKey && { sortParamKey })}
            {...rest}
        />
    );
};

export default EntityRelatedTable;
